import { z } from 'zod';

// --------------------------------------------------------------------------

const errorMessages = {
  required: 'This field is required',
};

// --------------------------------------------------------------------------

export const ContactUsSchema = z.object({
  r_First_Name: z
    .string({
      required_error: errorMessages.required,
    })
    .trim()
    .min(1, errorMessages.required),
  r_Last_Name: z
    .string({
      required_error: errorMessages.required,
    })
    .trim()
    .min(1, errorMessages.required),
  r_Email: z.string().email(),
  r_Phone: z.string().regex(/^[0-9]{10}$/, 'Phone number must be 10 digits.'),
  r_ZIP: z.string().regex(/^\d{5}$/, {
    message: 'ZIP code must be 5 digits',
  }),
  r_topic: z.string().refine((val) => val === 'another-topic'),
  'another-topic': z
    .string({
      required_error: errorMessages.required,
    })
    .trim()
    .min(1, errorMessages.required)
    .refine((val) => val.length <= 150, {
      message: "Message can't be more than 150 characters",
    }),
  'g-recaptcha-response': z
    .string({
      required_error: errorMessages.required,
    })
    .trim()
    .min(1, errorMessages.required),
});

// --------------------------------------------------------------------------

export type ContactUsFormSchema = z.infer<typeof ContactUsSchema>;
